function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import * as moment from "moment";

var VersionItem = function VersionItem(props) {
  var version = props.version;

  var formatDate = function formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD-MM-YYYY HH:mm");
  };

  var getEventLabel = function getEventLabel(event, itemType, objectChanges) {
    if (itemType === "PolizaComment") {
      if (event === "create") return "Comentario creado";
      if (event === "update") return "Comentario actualizado";
      if (event === "destroy") return "Comentario eliminado";
    } else if (itemType === "PolizaFile") {
      if (event === "create") return "Archivo subido";
      if (event === "update") return "Archivo actualizado";
      if (event === "destroy") return "Archivo eliminado";
    } else if (itemType === "Poliza") {
      // Si es una actualización de Poliza y cambia expiration_reminder_sent_at
      if (event === "update" && objectChanges && objectChanges.expiration_reminder_sent_at) {
        return "Recordatorio de vencimiento enviado";
      }

      if (event === "create") return "Póliza creada";
      if (event === "update") return "Póliza actualizada";
      if (event === "destroy") return "Póliza eliminada";
    }

    return event;
  };

  var getEventIcon = function getEventIcon(event) {
    if (event === "create") return "fa fa-plus-circle";
    if (event === "update") return "fa fa-edit";
    if (event === "destroy") return "fa fa-trash";
    return "fa fa-circle";
  };

  var getEventColor = function getEventColor(event) {
    if (event === "create") return "#28a745";
    if (event === "update") return "#ffc107";
    if (event === "destroy") return "#dc3545";
    return "#6c757d";
  };

  var formatDateValue = function formatDateValue(value) {
    if (!value) return "";

    try {
      var date = moment(value);

      if (date.isValid()) {
        return date.format("DD-MM-YYYY HH:mm");
      }
    } catch (e) {// Ignore
    }

    return String(value).substring(0, 50);
  };

  var formatFieldName = function formatFieldName(key) {
    var fieldNames = {
      expiration_reminder_sent_at: "Fecha de envío del recordatorio",
      content: "Contenido",
      management_type: "Tipo de Gestión",
      contact_method: "Medio de Contacto",
      next_step: "Próximo Paso",
      status: "Estado",
      file_type: "Tipo de Archivo",
      comment: "Comentario"
    };
    return fieldNames[key] || key.replace(/_/g, " ");
  };

  var renderChanges = function renderChanges() {
    if (!version.object_changes || Object.keys(version.object_changes).length === 0) {
      return null;
    }

    var changes = version.object_changes;
    var excludedKeys = ["updated_at", "created_at", "deleted_at", "file"];
    var filteredChanges = Object.entries(changes).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return !excludedKeys.includes(key);
    });

    if (filteredChanges.length === 0) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "8px",
        padding: "8px",
        backgroundColor: "#fff",
        borderRadius: "4px",
        fontSize: "12px"
      }
    }, filteredChanges.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      var oldValue = value && value[0] ? formatDateValue(value[0]) : "";
      var newValue = value && value[1] ? formatDateValue(value[1]) : ""; // Para expiration_reminder_sent_at, mostrar solo la nueva fecha si existe

      if (key === "expiration_reminder_sent_at" && newValue) {
        return /*#__PURE__*/React.createElement("div", {
          key: key,
          style: {
            marginBottom: "4px",
            paddingBottom: "4px",
            borderBottom: "1px solid #f0f0f0"
          }
        }, /*#__PURE__*/React.createElement("strong", null, formatFieldName(key), ":"), " ", /*#__PURE__*/React.createElement("span", {
          style: {
            color: "#28a745"
          }
        }, newValue));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: key,
        style: {
          marginBottom: "4px",
          paddingBottom: "4px",
          borderBottom: "1px solid #f0f0f0"
        }
      }, /*#__PURE__*/React.createElement("strong", null, formatFieldName(key), ":"), " ", oldValue && /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#dc3545"
        }
      }, oldValue), oldValue && newValue && /*#__PURE__*/React.createElement("span", {
        style: {
          margin: "0 5px"
        }
      }, "\u2192"), newValue && /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#28a745"
        }
      }, newValue));
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "12px",
      padding: "12px",
      border: "1px solid #e0e0e0",
      borderRadius: "6px",
      backgroundColor: "#fff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: getEventIcon(version.event),
    style: {
      color: getEventColor(version.event),
      marginRight: "8px",
      fontSize: "16px"
    }
  }), /*#__PURE__*/React.createElement("strong", {
    style: {
      fontSize: "13px",
      color: "#333"
    }
  }, getEventLabel(version.event, version.item_type, version.object_changes)), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "auto",
      fontSize: "12px",
      color: "#666"
    }
  }, formatDate(version.created_at))), version.comments && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "8px",
      padding: "8px",
      backgroundColor: "#f8f9fa",
      borderRadius: "4px",
      fontSize: "12px",
      fontStyle: "italic",
      borderLeft: "3px solid #2596be"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Comentario:"), " ", version.comments), renderChanges(), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "8px",
      fontSize: "11px",
      color: "#666"
    }
  }, "Por: ", /*#__PURE__*/React.createElement("strong", null, version.whodunnit || "Desconocido")));
};

export default VersionItem;